import React, {useState, useEffect} from 'react';
import { useStyles } from "./style";
import {connect } from "react-redux";
import mapStateToProps from './mapStateToProps';
import mapDispatchToProps from './mapDispatchToProps';
import modalStyles from 'components/ModalConfirmation/styles';
import ComponentePasarAFallecidosCiudadano from 'components/CustomDialog';
import ComparacionDeDatos from '../../QueTienenUnaCoincidenciaExacta/comparacionDeDatos';
import Homonimos from './Homonimos';
import Formulario from './Formulario';
import {Accordion, AccordionDetails, AccordionSummary, Typography} from '@material-ui/core/';
import {ExpandMore, FindInPage} from '@material-ui/icons/';

function DataComparisonDialog(props) {
    const classesModal = modalStyles(),
        classes = useStyles(),
        [datosHomonimos, setDatosHomonimos] = useState({}),
        [isSelectHomonimos, setIsSelectHomonimos] = useState(false),
        [expanded, setExpanded] = useState({
            panel1:'panel1',
            panel2:'panel2',
            panel3:'panel3',
        }
        );

    const handleChange = (panel) => (event, isExpanded) => {
        setExpanded(isExpanded ? panel : false);
        // setExpanded(panel);
    };

    useEffect(() => {
        props.MODULO_FALLECIDOS_SET_REGISTRO_HOMONIMOS_SELECCIONADO({})
        setDatosHomonimos({})
        setIsSelectHomonimos(false)
    }, [props.open])

    const FunctionisSelectHomonimos = () => {

    }
    return (
        <ComponentePasarAFallecidosCiudadano 
            titleToolbar={'Proceso de investigación'}
            iconToolbar={<FindInPage />}
            title={'Comparación de Datos'}
            open={props.open}
            fullScreen={true}
            closeModal={props.closeModal}
            actualizarTabla={props.actualizarTabla}
        >          
            <Accordion className={classes.accordionRoot}>
                <AccordionSummary
                    expandIcon={<ExpandMore />}
                    aria-controls="panel1bh-content"
                    id="panel1bh-header"                    
                >
                    <Typography className={classes.heading}>Comparación de datos</Typography>
                    <Typography className={classes.secondaryHeading}>Información de RENAP y PADRÓN</Typography>
                </AccordionSummary>
                <AccordionDetails className={classes.accordionBody}>
                    {
                        props.open && (
                            <ComparacionDeDatos 
                                datosDelCiudadanoAComparar={props.datosDelCiudadanoAComparar}                        
                            />                    
                        )
                    }                    
                </AccordionDetails>
            </Accordion >
            <Accordion className={classes.accordionRoot}>
                <AccordionSummary
                    expandIcon={<ExpandMore />}
                    aria-controls="panel2bh-content"
                    id="panel2bh-header"
                >
                    <Typography className={classes.heading}>Homónimos</Typography>
                    <Typography className={classes.secondaryHeading}>Buscar Homonimia en el padrón</Typography>
                </AccordionSummary>
                <AccordionDetails className={classes.accordionBody}>
                    <Homonimos open={props.open} setDatosHomonimos={setDatosHomonimos} setIsSelectHomonimos={setIsSelectHomonimos}/>
                </AccordionDetails>
            </Accordion>
            <Accordion className={classes.accordionRoot}>
                <AccordionSummary
                    expandIcon={<ExpandMore />}
                    aria-controls="panel3bh-content"
                    id="panel3bh-header"
                >
                    <Typography className={classes.heading}>Formulario</Typography>
                    <Typography className={classes.secondaryHeading}>Edición de datos</Typography>
                </AccordionSummary>
                <AccordionDetails className={classes.centerForm}>
                    <Formulario 
                        isSelectHomonimos={isSelectHomonimos} 
                        datosHomonimos={datosHomonimos} 
                        datosDelCiudadanoAComparar={props.datosDelCiudadanoAComparar[0]} 
                        open={props.open} 
                        closeModal={props.closeModal} 
                        actualizarTabla={props.actualizarTabla}
                        tableData={props.tableData}
                    />
                </AccordionDetails>
            </Accordion>
        </ComponentePasarAFallecidosCiudadano>
    );
}


export default connect(mapStateToProps, mapDispatchToProps)(DataComparisonDialog);